import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from '@mui/material';

const NoMatchupsCard = () => {
  return (
    <Card>
      <CardHeader
        title='SELECT PICKS'
        titleTypographyProps={{ flex: '1 1 100%', variant: 'h6' }}
      />
      <Divider />
      <CardContent>
        <Typography>Matchups to be determined</Typography>
      </CardContent>
    </Card>
  );
};

export default NoMatchupsCard;
